import { useId } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons'

import { Icon } from 'Components/Icon/Icon'

import type { DeviceHealthInfoTooltipProps } from './DeviceHealthInfoTooltip.types'

export const DeviceHealthInfoTooltip = (
  props: DeviceHealthInfoTooltipProps,
) => {
  const { translationId } = props
  const intl = useIntl()
  const tooltipId = useId()

  return (
    <OverlayTrigger
      overlay={
        <Tooltip id={tooltipId}>
          {intl.formatMessage({ id: translationId })}
        </Tooltip>
      }
      placement="top"
      trigger={['hover', 'focus']}
    >
      <button
        aria-label={intl.formatMessage({ id: translationId })}
        className="DeviceHealthInfoTooltip"
        type="button"
      >
        <Icon icon={faCircleInfo} size={16} />
      </button>
    </OverlayTrigger>
  )
}
